export const SAVE = 'step5.SAVE';
export const VALUE_CHANGED = 'step5.VALUE_CHANGED';
export const LOAD = 'step5.VALUE_LOAD';
export const RESET = 'step5.RESET';
export const RESET_CLAIM_TO_INJURY = 'step5.RESET_CLAIM_TO_INJURY';
export const RESET_DETAIL_OF_MEDICAL_CONDITIONAL = 'step5.RESET_DETAIL_OF_MEDICAL_CONDITIONAL';
export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST';
export const GET_COUNTRY_LIST_SUCCESS = 'GET_COUNTRY_LIST_SUCCESS';
export const GET_CITY_LIST = 'GET_CITY_LIST';
export const GET_CITY_LIST_SUCCESS = 'GET_CITY_LIST_SUCCESS';
export const GET_CLAIM_TYPES = 'GET_CLAIM_TYPES';
export const GET_CLAIM_TYPES_SUCCESS = 'GET_CLAIM_TYPES_SUCCESS';
export const VALIDATE_DATE_TIME_OF_EVENT = 'VALIDATE_DATE_TIME_OF_EVENT';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step5/constants.js